module.exports = __webpack_public_path__ + "img/villa_giulia_bellezza.cd1db81c.png";